<template>
    <router-link :to="`/times/${time.id}`">
        <div
            class="px-6 py-2 border border-gray-100 rounded shadow-sm hover:shadow transition duration-150"
        >
            <div class=" flex items-center">
                <span class="text-sm font-medium mr-4">#{{ time.id }}</span>
                <h3 class="flex-1">{{ time.tag }} - {{ time.tagEn }}</h3>
                <div class="hidden uppercase tracking-wide text-xs font-medium text-gray-500">
                    <span v-if="time.isVisible">Visible </span>
                    <span v-else> Hidden </span>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
export default {
    props: ['time'],
}
</script>
